import {
  type AppShellMode,
  type CoreFeatureFlags,
  type CurrentUser,
  resolveShellModeFromPath,
  resolveShellVisibility,
  type ShellModeRouteRule,
} from '@zhiyue/core';

type SessionSnapshot = {
  currentUser?: CurrentUser | null;
  currentTenantUuid?: string | null;
  loading: boolean;
  featureFlags: CoreFeatureFlags;
};

const DEFAULT_FEATURE_FLAGS: CoreFeatureFlags = {
  showHeader: true,
  showNav: true,
  showFooter: true,
  enableTenantSwitch: true,
  enableRegister: false,
};

let sessionSnapshot: SessionSnapshot = {
  currentUser: null,
  currentTenantUuid: null,
  loading: true,
  featureFlags: DEFAULT_FEATURE_FLAGS,
};

const SHELL_MODE_RULES: ShellModeRouteRule[] = [
  { path: '/callback', mode: 'canvas-only', exact: true },
  { path: '/user', mode: 'canvas-only' },
];

export const updateSessionSnapshot = (
  snapshot: Partial<SessionSnapshot>,
): void => {
  sessionSnapshot = {
    ...sessionSnapshot,
    ...snapshot,
    featureFlags: {
      ...sessionSnapshot.featureFlags,
      ...(snapshot.featureFlags || {}),
    },
  };
};

export const getSessionSnapshot = (): SessionSnapshot => {
  return sessionSnapshot;
};

export const resolveShellMode = (pathname: string): AppShellMode => {
  return resolveShellModeFromPath(pathname, SHELL_MODE_RULES, 'full');
};

export const getLayoutVisibility = (pathname: string) => {
  const mode = resolveShellMode(pathname);
  const { featureFlags } = getSessionSnapshot();
  const visibility = resolveShellVisibility(mode, featureFlags);

  return {
    mode,
    ...visibility,
  };
};
